<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>接口注册</el-breadcrumb-item>
            <el-breadcrumb-item>接口列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="5">
          <el-input size="small" style="margin-bottom:10px" v-model="searchName" placeholder="请输入API名称">
            <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
          </el-input>
        </el-col>
        <el-col :span="3" style="text-align: left; padding-left: 10px;">
          <el-button type="primary" size="small" @click="addApi" plain>注册API</el-button>
          <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
        </el-col>
        <el-col :span="16">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount" style="float:right"></el-pagination>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="ApiList" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="ID" label="APIID"></el-table-column>
            <el-table-column prop="Name" label="API名称"></el-table-column>
            <el-table-column prop="RequestURL" label="请求链接"></el-table-column>
            <el-table-column prop="Type" label="请求类型"></el-table-column>
            <el-table-column prop="RegisterTime" label="注册时间"></el-table-column>
            <el-table-column prop="IsOpen" :formatter="isOpen" label="是否启用"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="handleClickRow(scope.row)" size="small">接口详情</el-button>
                <el-button type="text" size="small">启用</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { GetApiPageList } from "../../until/ZeusApiSDK/Logic/ApiDataLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
export default {
  data() {
    return {
      searchName: "",
      ApiList: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true
    };
  },
  created() {
    this.GetAPIPageList();
  },
  methods: {

    //新增api接口
    addApi: function () {
      this.$router.push('/Api/EditApi');
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetAPIPageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetAPIPageList();
    },
    handleClickRow(row) {
    },
    SearchByName: function () {
      this.pageIndex = 1;
      this.GetAPIPageList();
    },
    Refresh: function () {
      this.GetAPIPageList();
    },
    GetRenewalPageList: function (name) {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      GetOrderPageList(
        userinfo.UserCode,
        "all",
        1,
        50,
        name
      ).then(pageRes => {
        this.Renewals = pageRes.DataList;
        this.loading = false;
      });
    },
    GetAPIPageList: function () {
      this.loading = true;
      var Predicates = [];
      Predicates.push(new Predicate("IsDelete", "0", "eq", 1));
      if (this.searchName) {
        Predicates.push(new Predicate("Name", this.searchName, "contain", 1));
      }
      GetApiPageList(
        Predicates,
        this.pageIndex,
        this.pageSize,
        "RegisterTime",
        "desc"
      ).then(pageRes => {
        this.ApiList = pageRes.DataList;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },

    isOpen(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "停止";
      } else if (cellValue == 1) {
        return "启用";
      }
    }
  }
};
</script>